import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Business = () => import('@/views/Business')
const About = () => import('@/views/About')
const Contact = () => import('@/views/Contact')
const Legal = () => import('@/views/Legal')
const Insights = () => import('@/views/Insights')
const Post = () => import('@/views/Post')
const Solutions = () => import('@/views/Solutions')
const Solution = () => import('@/views/Solution')

/* 每个路由带独立 title 与 description：利于收录，也避免所有页面共用一条描述 */
const routes = [
  { path: '/', redirect: '/home' },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: '首页',
      description: '海阳皓辰网络科技有限公司：智慧农业、工业物联网、MES 生产执行系统、企业服务四大业务线，提供从终端感知、边缘控制到平台应用的一体化产业数字化解决方案。'
    }
  },
  {
    path: '/agriculture',
    name: 'agriculture',
    component: Business,
    props: { lineKey: 'agriculture' },
    meta: {
      title: '智慧农业',
      description: '智慧农业解决方案：环境监测、智能灌溉与水肥一体、设施环境调控、农事台账与质量溯源，兼容存量设备，先小范围试点再扩展。'
    }
  },
  {
    path: '/iot',
    name: 'iot',
    component: Business,
    props: { lineKey: 'iot' },
    meta: {
      title: '工业物联网',
      description: '工业物联网解决方案：协议解析与设备接入、产线状态监测、远程控制与定时任务、预测性维护与能耗管理，存量设备免停机接入。'
    }
  },
  {
    path: '/enterprise',
    name: 'enterprise',
    component: Business,
    props: { lineKey: 'enterprise' },
    meta: {
      title: '企业服务',
      description: '企业服务：数字化咨询、定制软件开发、数据平台建设、系统集成与驻场实施，从需求梳理到上线验收与运维迭代全程负责。'
    }
  },
  {
    path: '/mes',
    name: 'mes',
    component: Business,
    props: { lineKey: 'mes' },
    meta: {
      title: 'MES 生产执行系统',
      description: 'MES 生产执行系统：生产调度与工单管理、工艺与工序管控、在制品流转管控、质量追溯、线边物料协同与工时绩效分析，适配离散制造与流程制造车间。'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      title: '关于我们',
      description: '关于皓辰科技：公司简介、四大业务线（含 MES 生产执行系统）、发展历程与价值观，办公地址位于山东省烟台市海阳市经发商务中心 609 室。'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: '联系我们',
      description: '联系皓辰科技：电话、邮箱、微信与办公地址，提交需求后工作日 1 天内响应；可申请在线演示环境账号并安排线上讲解。'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Legal,
    props: { kind: 'privacy' },
    meta: {
      title: '隐私政策',
      description: '皓辰科技官网隐私政策：说明我们收集哪些信息、如何使用与保护，以及你可行使的权利与联系方式。'
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: Legal,
    props: { kind: 'terms' },
    meta: {
      title: '服务条款',
      description: '皓辰科技官网服务条款：网站内容说明、知识产权、在线演示环境使用规则与责任范围。'
    }
  },
  {
    path: '/insights',
    name: 'insights',
    component: Insights,
    meta: {
      title: '行业洞察',
      description: '皓辰科技行业洞察：MES 生产执行系统与智慧农业的选型、实施与落地经验，覆盖工单管理、工序管控、生产追溯、环境监测、水肥一体化、农业溯源等主题。'
    }
  },
  {
    path: '/insights/:slug',
    name: 'post',
    component: Post,
    meta: {
      /* 文章页的 title / description 由 Post.vue 按 slug 自行设置（见该组件 sync()），
         这里只作兜底；afterEach 对 name==='post' 直接跳过，避免被静态文案覆盖。 */
      title: '行业洞察',
      description: ''
    }
  },
  {
    path: '/solutions',
    name: 'solutions',
    component: Solutions,
    meta: {
      title: '解决方案与功能域',
      description: '皓辰科技解决方案与功能域索引：智慧农业的设备接入、设备管控、环境监测、水肥一体化、虫情 AI 识别与溯源存证，以及 MES 的工单工序与质量追溯。'
    }
  },
  {
    path: '/solutions/:slug',
    name: 'solution',
    component: Solution,
    props: true,
    meta: {
      /* 功能域页的 title / description 由 Solution.vue 按 slug 自行设置（见该组件 syncMeta），
         这里只作兜底；afterEach 对 name==='solution' 直接跳过，避免被静态文案覆盖。 */
      title: '解决方案',
      description: ''
    }
  },
  { path: '*', redirect: '/home' }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash, offset: { x: 0, y: 90 } }
    return { x: 0, y: 0 }
  },
  routes
})

const BASE_TITLE = '皓辰科技 HOYOTECH'
const DEFAULT_DESC = '海阳皓辰网络科技有限公司：智慧农业、工业物联网、MES 生产执行系统、企业服务四大业务线，提供一体化产业数字化解决方案。'

/** 同步每页描述：SPA 下爬虫主要读静态 index.html，这项对人分享/SEO 工具与浏览器仍有效 */
const setDescription = (desc) => {
  let el = document.querySelector('meta[name="description"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', 'description')
    document.head.appendChild(el)
  }
  el.setAttribute('content', desc || DEFAULT_DESC)
}

/**
 * 同步当前页的 canonical 与 og:url。
 *
 * ⚠️ 这项必须做，而且不能只在首屏做：
 * SPA 客户端跳转不会重新加载 HTML，<head> 里的 canonical 会**一直停留在上一页**。
 * 爬虫顺着站内链接爬过去时，会读到「B 页声明 canonical 是 A 页」，
 * 结果是新页可能被判成重复内容而不被收录——页面本身完全正常，只有爬虫看得见这个问题。
 * 预渲染只解决「首次直达」的正确性，客户端跳转必须在这里兜住。
 */
const setCanonical = (to) => {
  // 去掉 query 与 hash，只保留路径；根路径统一为 /home（与预渲染脚本的规则一致）
  let path = to.path || '/'
  if (path === '/') path = '/home'
  const href = `${window.location.origin}${path}`

  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)

  let og = document.querySelector('meta[property="og:url"]')
  if (!og) {
    og = document.createElement('meta')
    og.setAttribute('property', 'og:url')
    document.head.appendChild(og)
  }
  og.setAttribute('content', href)
}

router.afterEach((to) => {
  // canonical 与 og:url 对所有路由都要同步（包括 post / solution，它们只接管 title 与 description）
  setCanonical(to)
  // 文章详情页自己按 slug 设置标题与描述，这里不能覆盖，否则每篇都是「行业洞察」
  if (to.name === 'post') return
  // 功能域详情页同理，由 Solution.vue 按 slug 自行设置
  if (to.name === 'solution') return
  const meta = to.meta || {}
  document.title = meta.title ? `${meta.title} · ${BASE_TITLE}` : BASE_TITLE
  setDescription(meta.description)
})

export default router
